// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3C43K","header":"PatientQuestionnaire_header__Janw5","info":"PatientQuestionnaire_info__Wnxra"};